import React, { useState, useEffect } from 'react'
import {
    Box,
    Collapse,
    Dialog,
    DialogContent,
    IconButton,
    Typography,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import Provider from 'components/admin/Provider'
import ProviderProgressCards from 'components/admin/ProviderProgressCards'

function ProviderModal({ open, onClose, provider, brands, updateProviders }) {
    const [currentCompany, setCurrentCompany] = useState(provider)
    const [checklistOpen, setChecklistOpen] = useState(true)

    // Keep local company in sync when the parent swaps to a different provider
    useEffect(() => {
        setCurrentCompany(provider)
    }, [provider])

    if (!provider) return null

    function handleCompanyChange(updated) {
        setCurrentCompany(updated)
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth='xl' fullWidth scroll='paper'>
            {/* ── Non-scrolling header ─────────────────────────────────── */}
            <Box
                display='flex'
                alignItems='center'
                justifyContent='space-between'
                px={3}
                py={2}
                style={{ borderBottom: '1px solid #e9ecef', flexShrink: 0 }}
            >
                <Typography variant='h3' style={{ margin: 0 }}>
                    {provider.name}
                </Typography>
                <IconButton size='small' onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Box>

            {/* ── Pinned checklist cards ───────────────────────────────── */}
            {currentCompany && (
                <Box
                    style={{ borderBottom: '1px solid #e9ecef', flexShrink: 0, backgroundColor: '#f8f9fe' }}
                >
                    <Box
                        display='flex'
                        alignItems='center'
                        justifyContent='space-between'
                        px={3}
                        py={1}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setChecklistOpen(o => !o)}
                    >
                        <Typography variant='subtitle2' style={{ fontWeight: 700, color: '#32325d', margin: 0 }}>
                            Onboarding Progress
                        </Typography>
                        <IconButton size='small'>
                            {checklistOpen ? <ExpandLessIcon fontSize='small' /> : <ExpandMoreIcon fontSize='small' />}
                        </IconButton>
                    </Box>
                    <Collapse in={checklistOpen}>
                        <Box px={3} pb={2}>
                            <ProviderProgressCards company={currentCompany} />
                        </Box>
                    </Collapse>
                </Box>
            )}

            {/* ── Scrollable content ───────────────────────────────────── */}
            <DialogContent style={{ padding: '1.5rem' }}>
                <Provider
                    key={provider.companyId}
                    provider={provider}
                    brands={brands}
                    updateProviders={updateProviders}
                    onCompanyChange={handleCompanyChange}
                />
            </DialogContent>
        </Dialog>
    )
}

export default ProviderModal
